export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatINR = (n) => `₹${Number(n).toLocaleString("en-IN")}`;
